if (!customElements.get('index-banner-list')) {
  customElements.define(
    'index-banner-list',
    class IndexBannerList extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        requestAnimationFrame(() => this.initSlider());
      }

      disconnectedCallback() {
        this._initialized = false;
        this._navBindings?.forEach(({ el, fn }) => el.removeEventListener('click', fn));
        this._navBindings = null;
        this._resizeObserver?.disconnect?.();
        this._resizeObserver = null;
        if (this._onResize) {
          window.removeEventListener('resize', this._onResize);
          this._onResize = null;
        }
        if (this._slider?.destroy) {
          this._slider.destroy(true, true);
        }
        this._slider = null;
      }

      initSlider() {
        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          loop: false,
          navigation: false,
        };

        const carousel = new window.FoxTheme.Carousel(this, options, []);
        carousel.init();
        this._slider = carousel.slider;

        // Ensure correct size/translate after initial layout and any later resizes.
        const update = () => {
          const s = this._slider;
          if (!s || this.offsetWidth === 0) return; // Ensure element is visible
          if (typeof s.updateSize === 'function') s.updateSize();
          if (typeof s.updateSlides === 'function') s.updateSlides();
          if (typeof s.updateProgress === 'function') s.updateProgress();
          if (typeof s.updateSlidesClasses === 'function') s.updateSlidesClasses();
          if (typeof s.update === 'function') s.update();
        };

        const updateBannerPagination = () => {
          const cur = this.querySelector('[data-banner-pagination-current]');
          const s = this._slider;
          if (!cur || !s) return;
          const n = (typeof s.activeIndex === 'number' ? s.activeIndex : 0) + 1;
          cur.textContent = String(n).padStart(2, '0');
        };

        requestAnimationFrame(() => {
          update();
          if (typeof this._slider?.slideTo === 'function') this._slider.slideTo(this._slider.activeIndex || 0, 0);
          updateBannerPagination();
        });

        const syncWaterCurveSlideClasses = () => {
          const s = this._slider;
          if (typeof s?.updateSlidesClasses === 'function') {
            s.updateSlidesClasses();
          }
        };

        if (this._slider && typeof this._slider.on === 'function') {
          this._slider.on('slideChangeTransitionStart', syncWaterCurveSlideClasses);
          this._slider.on('slideChange', updateBannerPagination);
        }

        if (typeof ResizeObserver !== 'undefined') {
          this._resizeObserver = new ResizeObserver(() => update());
          this._resizeObserver.observe(this);
        } else {
          this._onResize = () => update();
          window.addEventListener('resize', this._onResize, { passive: true });
        }

        this._navBindings = [];
        this.querySelectorAll('.swiper-button-prev.ig, .swiper-button-next.ig').forEach((el) => {
          const fn = (e) => {
            e.preventDefault();
            if (el.classList.contains('swiper-button-prev')) this._slider?.slidePrev();
            else this._slider?.slideNext();
            el.blur(); // Remove focus so the browser doesn't try to auto-scroll back to it when the tab becomes visible again
          };
          el.addEventListener('click', fn);
          this._navBindings.push({ el, fn });
        });
      }
    }
  );
}
